import { onMounted, onUnmounted, watchEffect } from 'vue'

export function useMeta(metaData) {
  const metaElements = []

  const updateMeta = () => {
    // Clear previous meta tags
    metaElements.forEach(element => {
      if (element.parentNode) {
        element.parentNode.removeChild(element)
      }
    })
    metaElements.length = 0

    // Update document title
    if (metaData.title) {
      document.title = metaData.title
    }

    // Update meta tags
    if (metaData.meta) {
      metaData.meta.forEach(meta => {
        const element = document.createElement('meta')
        
        Object.keys(meta).forEach(key => {
          element.setAttribute(key, meta[key])
        })
        
        document.head.appendChild(element)
        metaElements.push(element)
      })
    }

    // Update Open Graph tags
    if (metaData.og) {
      Object.keys(metaData.og).forEach(key => {
        const element = document.createElement('meta')
        element.setAttribute('property', `og:${key}`)
        element.setAttribute('content', metaData.og[key])
        document.head.appendChild(element)
        metaElements.push(element)
      })
    }

    // Update Twitter Card tags
    if (metaData.twitter) {
      Object.keys(metaData.twitter).forEach(key => {
        const element = document.createElement('meta')
        element.setAttribute('name', `twitter:${key}`)
        element.setAttribute('content', metaData.twitter[key])
        document.head.appendChild(element)
        metaElements.push(element)
      })
    }

    // Update structured data (JSON-LD)
    if (metaData.structuredData) {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify(metaData.structuredData)
      document.head.appendChild(script)
      metaElements.push(script)
    }
  }

  onMounted(() => {
    watchEffect(updateMeta)
  })

  onUnmounted(() => {
    // Clean up meta tags when component is unmounted
    metaElements.forEach(element => {
      if (element.parentNode) {
        element.parentNode.removeChild(element)
      }
    })
  })

  return {
    updateMeta
  }
}
